import React from "react";
import {
  Box,
  Container,
  Heading,
  Text,
  VStack,
  useColorModeValue,
  Divider,
} from "@chakra-ui/react";

const StrategicPartnershipsSection = ({ data }) => {
  const textColor = useColorModeValue("gray.600", "gray.400");
  const headingColor = useColorModeValue("#000B8C", "blue.400");
  const accentColor = useColorModeValue("#000B8C", "blue.300");

  // Use API data if available, otherwise show loading or fallback
  if (!data) {
    return (
      <Box py={{ base: 8, md: 10, lg: 12 }}>
        <Container maxW="8xl" px={{ base: 6, md: 8, lg: 12 }}>
          <Text textAlign="center" color="gray.500">
            Loading...
          </Text>
        </Container>
      </Box>
    );
  }

  return (
    <Box>
      <Container maxW="8xl" px={{ base: 6, md: 8, lg: 12 }}>
        <VStack spacing={{ base: 8, md: 10 }} align="center">
          {/* Main Heading - Dynamic from API */}
          {/* <VStack spacing={4} textAlign="center">
            <Heading
              as="h2"
              fontSize={{ base: "2xl", md: "3xl", lg: "4xl" }}
              color={headingColor}
              fontWeight="bold"
              lineHeight="1.2"
              maxW="5xl"
              letterSpacing="-0.02em"
            >
              {data.title}
            </Heading>
            
            <Divider 
              w="60px" 
              borderColor={accentColor} 
              borderWidth="2px" 
              mx="auto" 
            />
          </VStack> */}

          {/* Description Text - Dynamic from API */}
          <Box maxW="7xl" w="full">
            <Text
              fontSize={{ base: "lg", md: "xl", lg: "xl" }}
              color={textColor}
              lineHeight="1.7"
              textAlign="justify"
              fontWeight="400"
              letterSpacing="0.01em"
            >
              {data.description}
            </Text>
          </Box>
        </VStack>
      </Container>
    </Box>
  );
};

export default StrategicPartnershipsSection;
